import Image from 'next/image';

import { IResolvedSteppersItem } from '@/src/utils/collections/steppers.mapper';
import { IIconType, IImageType } from '@/src/types';

interface ISteppersItemProps extends IResolvedSteppersItem {
  last?: boolean;
  showStepperLine?: boolean;
  isIcon: boolean;
}

export const SteppersItem = ({
  title,
  description,
  last,
  showStepperLine,
  media,
  isIcon,
}: ISteppersItemProps) => {
  return (
    <div className={`relative flex flex-1 flex-row items-start`}>
      {showStepperLine && !last && (
        <div
          className={`absolute bottom-0 left-[27px] top-[56px] border-[1.5px] border-primary`}
        />
      )}
      {isIcon ? (
        <Image
          className={'min-h-0 min-w-0'}
          src={(media as IIconType).icon}
          alt={media?.alt || ''}
          width={56}
          height={56}
        />
      ) : (
        <Image
          placeholder={'blur'}
          blurDataURL={'/static/images/placeholder.webp'}
          className={'min-h-0 min-w-0 md:mx-auto'}
          src={(media as IImageType).image}
          alt={media?.alt || ''}
          width={320}
          height={450}
          layout={'responsive'}
        />
      )}
      <div className={`mb-4 ml-4 max-w-80 flex-1 space-y-2`}>
        <div className={`text-xl font-semibold leading-6`}>{title}</div>
        <div className={'text-base text-gray'}>{description}</div>
      </div>
    </div>
  );
};
